import { Injectable, NgZone } from '@angular/core';
import { CommonService } from './common.service';
import { DataService } from './data.service';
import { AIRWebViewChannel, AutoWebSocketChannel, WebSocketGateway, WebViewGateway } from './gateway/WebViewGateway';
import { ExponentialBackoffPolicy } from './gateway/policy';
import { SettingService } from './setting.service';
import { environment } from 'src/environments/environment';

var win: any = window;
win.edgeHashChange = true;

export class SingleROService {
	private hashQueue: any[] = [];
	private callingId: any = null;
	private curRetryNum: any = null;

	private callId: number = 1;
	private checkMultipartSupport: boolean = true;
	private supportMutipart: boolean = true;

	private socket: WebSocket | null = null;
	private gateway: WebViewGateway | null = null;
	constructor(
		// private coms:CommonService, private datas: DataService, private ngZone: NgZone
		private dev: any,
		private options:any
	) {
		this.init();
	}

	private async init() {
		this.initROCallback();
		if(this.options.appId == "rainbowsky")
		{
			this.gateway = new WebViewGateway();
			var ws:string = this.options.ws ?? "";
			var channels = [
				new AIRWebViewChannel({}),
				new AutoWebSocketChannel(
					{
						ws:ws,
						name: "client",
						policy: new ExponentialBackoffPolicy(1000, 15000, 99999999)
					}
				)
			];
			var channel = await this.gateway.pickConnection(channels);
			if (channel) {
				console.log("pick", channel.constructor.name, "channel");
			} else {
				try {
					this.gateway.dispose();
					this.gateway = null;
					this.initAIRGateway();
				} catch (reason: any) {
					console.error(reason);
				}
			}
		}

	}
	public reset() {
		var queue = this.hashQueue;
		var win: any = window;
		var ro: any = win.ro;
		for (var i = 0; i < queue.length; i++) {
			var hashObj = queue[i];
			if (ro) {
				console.log("reset", hashObj);
				ro.callback(hashObj.id, 400, 'Cancel');
				ro.deleteCall(hashObj.id);
			}
		}
		this.hashQueue = [];
	}

	private initROCallback() {
		const w: any = window;
		w.ro = {
			calls: {},
			callback: (callId: number, status: any, data: string) => {
				//this.coms.log('RoReturn status: ' + status);
				if (status == 'ack') {
					console.log('ack', callId);
					//this.coms.log('Got ACK of call id: ' + callId);
					if (this.callingId == callId) {
						this.callingId = null;
						this.curRetryNum = null;
						this.nextHash();
					};
				} else {
					console.log('end', callId);

					//this.coms.log('RoReturn data: ' + JSON.stringify(data));
					let call = w.ro.calls[callId];
					if (call) {
						(status == 200) ? call.resolve(data) : call.reject(data);
						//delete window['ro'].calls[callId];
						w.ro.deleteCall(callId);
					}
				}
			},
			deleteCall: (callId: number) => {
				delete w.ro.calls[callId];
			}
		};
	}
	private async initAIRGateway() {
		const w: any = window;
		const dev = this.dev;

		// 監聽來自原生端 (AIR) 的 message 事件
		if (!w.watchAIRMessage) {
			w.watchAIRMessage = (event: MessageEvent) => {
				if (typeof event.data === 'string') {
					const data: any = JSON.parse(event.data);
					if (data[0] == "app") {
						// "app message", name, parameters
						if (data[1] == "window.ro.callback") {
							w.ro.callback.apply(null, data[2]);
						}
					}
				}
			};

			if (dev.isWindows) {
				if (w.chrome.webview) {
					w.chrome.webview.addEventListener("message", w.watchAIRMessage);
				}
			} else if (dev.isMac) {
				w.addEventListener("message", w.watchAIRMessage);
			} else if (dev.isAndroid) {
				w.addEventListener("message", w.watchAIRMessage);
				// window.addEventListener("message", eventHandlerFunction) and if the event object has a data value of messagePort then assign event.ports[0] to a variable.
			}
			// iOS 未支援
		}
	}
	/*
	airSocketConnect() {
		if(this.socket || !this.dev.isMac) return;

		this.socket = new WebSocket('ws://127.0.0.1:8866');
		this.socket.onmessage = (event) => {
			//const data = JSON.parse(event.data);
			// 處理來自 AIR 的回傳
		};

		this.socket.onerror = (error) => {
			if(this.socket)
			{
				console.log('Socket 錯誤，可能 AIR 端還沒準備好');
				// 這裡可以實作重連機制，防止初始化時的閃退
				this.socket.close();
				this.socket = null;
			}
			setTimeout(() => this.airSocketConnect(), 2000);
		};
	}

	airSocketSend(msg: string) {
		if (this.socket) {
			this.socket.send(msg);
		}
	}
	*/
	private usingLocationHash(): boolean {
		const dev = this.dev;
		if (dev.isWindows || dev.isMac || dev.isAndroid) {
			return false;
		} else {
			return true;
		}
	}


	private messageToAIR(data: string): void {
		const dev = this.dev;
		const w: any = window;

		if (dev.isWindows || dev.isMac || dev.isAndroid) {
			//console.log('👀#', location.href);
			data = window.location.origin + window.location.pathname + "#" + data;
			if (w.AIR) {
				// 針對 Android 版 AIR StageWebView
				console.log('‼️‼️‼️air', data.split("#")[1].split("/")[2]);
				w.AIR.postMessage(data);
			} else if (w.webkit && w.webkit.messageHandlers && w.webkit.messageHandlers.as3) {
				// 針對 macOS
				console.log('‼️‼️‼️as3', data.split("#")[1].split("/")[2]);
				w.webkit.messageHandlers.as3.postMessage(data);
			} else if (w.chrome && w.chrome.webview) {
				// 針對 Windows Edge
				console.log('‼️‼️‼️chrome', data.split("#")[1].split("/")[2]);
				w.chrome.webview.postMessage(data);
			}
		} else {
			// iOS 未支援，只能用 url 方式
			window.location.hash = data;
		}
	}

	//---------------------------------------------------------------------------------------------
	private lastRequestTime: number = 0;
	//---------------------------------------------------------------------------------------------
	public prepareResponse(resolve: Function, reject: Function): any {
		var w: any = window;
		let callId: number = this.callId++;
		var response = { id: callId, resolve: resolve, reject: reject };
		w.ro.calls[callId] = response;
		return response;
	}
	//---------------------------------------------------------------------------------------------
	public async request(name: string, data: any = {}, timeoutReject: boolean = true, prefix: string = "ro/request"): Promise<any> 
	{
		if (this.gateway) {
			
			try
			{
				return await this.gateway.request(
					name, data,
					timeoutReject ? { policy: new ExponentialBackoffPolicy(1000, 15000, 7) } : undefined
				);
			} catch(reason:any)
			{
				if(reason && reason.type == "no_connection")
				{
					
				} else {
					if(name == "0")
					{
						return {};
					}
					console.error(name +">" + JSON.stringify(reason));
					return Promise.reject(reason);
				}
			}
			
		}

		const callName: string = [prefix, name].join("/");
		return new Promise((resolve, reject) => {
			var response: any = this.prepareResponse(resolve, reject);
			this.callRo(callName, data, response, timeoutReject);
		});
	}
	/*
		public request(name:string, data:any={}, timeoutReject:boolean=true, prefix:string="ro/request"):Promise<any> {
			if(this.gateway)
			{
				return this.gateway.request(
					name, data,
					// timeoutReject ? {maxRetries:7,timeout:15000,retryInterval:1000} : undefined
					timeoutReject ? {policy :  new ExponentialBackoffPolicy(1000, 15000, 7)} : undefined
					// timeoutReject ? {maxRetries:10,timeout:15,retryInterval:1000} : null
				);
			}
			let callName:string = [prefix, name].join("/");
			return new Promise((resolve, reject)=>{
				var response:any = this.prepareResponse(resolve, reject);
				this.callRo(callName, data, response, timeoutReject);
			});
		}
	*/
	public notifyAppInfo(): void {
		this.request("notifyAppInfo", { accessToken: localStorage.getItem('common_jwt') });
	}
	//---------------------------------------------------------------------------------------------
	/*public ready() {
		let callName:string = "ro/ready";
		this.coms.log('in ro.service.request, name: ' + callName);
		return new Promise((resolve, reject)=>{
			var response:any = this.prepareResponse(resolve, reject);
			this.callRo(callName, {}, response, false);
		});
	}*/
	//---------------------------------------------------------------------------------------------
	private callRo(name: string, data: any = {}, response: any = {}, timeoutRejct: boolean): void {
		if (!this.checkMultipartSupport) {
			//this.coms.log('in ro.service.callRo.checkMultipartSupport');
			let supportMultiPartResponse: any = this.prepareResponse(
				() => {
					this.checkMultipartSupport = true;
					this.supportMutipart = true;
					//this.coms.log('in ro.service.callRo.checkMultipartSupport, supportMutipart: ' + this.supportMutipart);
					this.callRo(name, data, response, timeoutRejct);
				},
				() => {
					this.checkMultipartSupport = true;
					//this.coms.log('in ro.service.callRo.checkMultipartSupport, supportMutipart: ' + this.supportMutipart);
					this.callRo(name, data, response, timeoutRejct);
				}
			);
			this.simpleCall("ro/request/supportMultiPart", "", supportMultiPartResponse, true);
			/*setTimeout(()=>{
				if (!this.checkMultipartSupport) supportMultiPartResponse.reject();
			},6000);*/
		} else {
			this.middleWareCall(name, data, response, timeoutRejct);
		}
	}
	//---------------------------------------------------------------------------------------------
	private middleWareCall(name: string, data: any = {}, response: any = {}, timeoutRejct: boolean): void {
		//this.coms.log('in ro.service.middleWareCall, supportMutipart: ' + this.supportMutipart);
		if (this.supportMutipart) {
			this.multiplePartRequest(name, data, response, timeoutRejct);
		} else {
			this.encodedRequest(name, data, response, timeoutRejct);
		}
	}
	//---------------------------------------------------------------------------------------------
	private toHex(tmp: String): String {
		var tmp_len = tmp.length;
		var parts = [];
		for (var i = 0; i < tmp_len; i += 1) {
			var charCode = tmp.charCodeAt(i);
			parts.push(charCode.toString(16));
		}
		return parts.join(",");
	}
	private splitHex(hex: String): string[] {
		var out = [];
		while (hex.length > 0) {
			out.push(hex.substr(0, 512));
			hex = hex.substring(512);
		}
		return out;
	}
	private multiplePartRequest(name: string, data: any = {}, response: any = {}, timeoutRejct: boolean): void {
		// 新 AIR SDK 可以直和 app 通訊不經 url 及可 send 較大資料，所以不分拆了
		const dev = this.dev;
		if (dev.isWindows || dev.isMac || dev.isAndroid) {
			this.encodedRequest(name, data, response, timeoutRejct);
			return;
		}

		//this.coms.log('in ro.service.multiplePartRequest, name: ' + name + '  data: ' + JSON.stringify(data));
		let json: String = JSON.stringify(data);
		if (json.length > 480) {
			let hexJSON = this.toHex(json);
			let array = this.splitHex(hexJSON);
			var len = array.length;

			let curIndex: number = 0;
			let loopFn: Function = () => {
				if (curIndex < len) {
					this.simpleCall(
						"ro/request/append",
						"id(" + response.id + ")-index(" + curIndex + ")-total(" + (len - 1) + ")-hex(" + array[curIndex] + ")",
						this.prepareResponse(
							() => {
								//curIndex++;
								//loopFn();
							}, () => {
								//error
								response.reject();
							}
						),
						false
					);
					curIndex++;
					loopFn();
				} else {
					//Last call
					this.simpleCall(name, "", response, timeoutRejct);
				}
			};
			loopFn();
		} else {
			this.encodedRequest(name, data, response, timeoutRejct);
		}
	}

	// this behavior is different from original Jimmy's version
	private encodedRequest(name: string, data: any = {}, response: any = {}, timeoutRejct: boolean): void {
		//this.coms.log('in ro.service.encodedRequest, name: ' + name + '  data: ' + JSON.stringify(data));
		//this.coms.log('encodedRequest Name: ' + name);
		//this.coms.log('encodedRequest Data: ' + JSON.stringify(data));
		this.simpleCall(name, encodeURIComponent(btoa(unescape(encodeURIComponent(JSON.stringify(data))))), response, timeoutRejct);
	}
	// final call to RO
	private simpleCall(name: string, data: string = '', response: any = {}, timeoutRejct: boolean): void {
		//this.coms.log('in ro.service.simpleCall, name: ' + name + '  data: ' + JSON.stringify(data));
		let hash: string = [name, "window.ro.callback", response.id, data, this.now()].join("/");
		this.assignHash2(hash, response.id, name, timeoutRejct);
	}


	private assignHash2(hash: string, callId: number, name: string, timeoutRejct: boolean, retry: number = 0): void {
		this.hashQueue.push({
			id: callId,
			hash: hash,
			name: name,
			timeoutRejct: timeoutRejct,
			retry: retry
		});

		this.nextHash();
	}

	private nextHash(): void {
		// if (this.callingId!=null || this.hashQueue.length<1) return;
		if (this.callingId != null) return;
		if (this.usingLocationHash() && this.isCalling()) {
			// const apiName = this.hashQueue[0].name.substr(11);
			// this.coms.log('HTTP is calling[' + apiName + '], wait 1 sec.');
			setTimeout(() => this.nextHash(), 1000);
			return;
		}

		if (this.hashQueue.length < 1) {
			if (this.usingLocationHash()) {
				window.location.hash = "";
			}
			return;
		}

		let hashObj: any = this.hashQueue.shift();
		this.callingId = hashObj.id;
		this.curRetryNum = hashObj.retry;

		this.messageToAIR(hashObj.hash);

		//this.coms.log('hash: ' + hashObj.hash);
		setTimeout(() => {
			//this.coms.log('callingId: ' + this.callingId + '   curRetryNum: ' + this.curRetryNum + '   hashObj.id: ' + hashObj.id + '   hashObj.retry: ' + hashObj.retry);
			if (this.callingId == hashObj.id && this.curRetryNum == hashObj.retry) {
				console.log('retry', hashObj.id, this.callingId);
				if (hashObj.name != 'ro/request/append' && hashObj.name.indexOf('ro/ready') < 0) {
					var w: any = window;
					if (hashObj.retry < 3) {
						// this.coms.log('retry ro call: ' + hashObj.name + '   id: ' + hashObj.id + '   retry: ' + (hashObj.retry + 1));
						this.assignHash2(hashObj.hash, hashObj.id, hashObj.name, hashObj.timeoutRejct, hashObj.retry + 1);
					} else {
						//this.coms.log('Did not get "ack" from RO for "' + hashObj.name + '"(id:' + hashObj.id + ') in 1 sec. Will call next.');
						if (hashObj.timeoutRejct) w['ro'].callback(hashObj.id, 408, 'Request Timeout.');
						w['ro'].deleteCall(hashObj.id);
					}
				}
				this.callingId = null;
				this.curRetryNum = null;
				this.nextHash();
			}
		}, 1000);
	}

	private assignHash(hash: string) {
		this.delay(() => {
			this.lastRequestTime = this.now();
			window.location.hash = hash;
		});
	}

	private now() {
		return new Date().getTime();
	}

	private delay(fn: Function) {
		if (new Date().getTime() > this.lastRequestTime + 500) {
			fn();
		} else {
			setTimeout(() => { this.delay(fn) }, 500);
		}
	}
	//---------------------------------------------------------------------------------------------
	private isCalling(): boolean {
		var w: any = window;
		return (w['httpCalling'] && w['httpCalling'].length > 0);
	}
	//---------------------------------------------------------------------------------------------

}


var roServiceInstance: SingleROService | null = null;
@Injectable({ providedIn: 'root' })
export class RoService {
	instance !: SingleROService;
	public enabled: boolean = false;
	isInWeb: boolean = true;

	constructor(/*public setting: SettingService, */private coms: CommonService, private datas: DataService, private ngZone: NgZone) {
		this.updateEnable();
		if(roServiceInstance)
		{
			this.instance = roServiceInstance;
		}
	}

	public init()
	{
		if (!roServiceInstance) {
			roServiceInstance = new SingleROService(
				this.datas.dev,
				{
					appId:this.datas.appId,
					ws:environment.wsGateway
				}
			);
		}
		this.instance = roServiceInstance;
	}
	public reset() {
		if (roServiceInstance) roServiceInstance.reset();
	}

	updateEnable() {
		var isInApp = this.coms.isWebView();
		this.isInWeb = !isInApp || localStorage.getItem('in-web') == '1';
		this.enabled = !this.isInWeb;
	}
	//---------------------------------------------------------------------------------------------
	//---------------------------------------------------------------------------------------------
	public request(name: string, data: any = {}, timeoutReject: boolean = true, prefix: string = "ro/request"): Promise<any> {
		if(!this.instance) return Promise.reject("ros not init");
		
		if (this.enabled == false) return Promise.reject({ msg: 'in-web' });

		let callName: string = [prefix, name].join("/");
		let p = this.instance.request(name, data, timeoutReject, prefix);
		//this.coms.log('in ro.service.request, name: ' + callName);
		this.coms.log('ro.request(' + callName + ',     data: ' + JSON.stringify(data));
		p.then(() => {
			this.coms.log('response(' + callName + ') OK');
		},
			(reason) => {
				this.coms.log('error response:' + callName + '     failed: ' + JSON.stringify(reason));
			});
		return p;
	}

	public notifyAppInfo(): void {
		if (this.enabled) {
			this.request("notifyAppInfo", { accessToken: localStorage.getItem('common_jwt') });
		}
	}

}
